import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

const ARS_FORMATTER = new Intl.NumberFormat("es-AR", {
  style: "currency",
  currency: "ARS",
  minimumFractionDigits: 0,
  maximumFractionDigits: 0,
});

/**
 * Combina clases de Tailwind con clsx + tailwind-merge.
 * @param {...any} inputs
 * @returns {string}
 */
export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

/**
 * @param {number} value
 * @returns {string}
 */
export const formatPrice = (value) => ARS_FORMATTER.format(value);

/**
 * @param {string} value
 * @returns {boolean}
 */
export const isValidEmail = (value) =>
  /\S+@\S+\.\S+/.test(String(value || "").trim());
